export * from './sincronizador-equipamento.componente';
export * from './controllers/sincronizador.controller';
export * from './sincronizador-equipamento.module';
